import { useQuery } from "@tanstack/react-query";
import { dashboardService, type ComingSoonModule } from "./dashboardService";

/**
 * 即将上线模块(status=coming_soon)。唯一来源 = 后端 xb_module_catalog(经 /me/modules/coming-soon,租户可读)。
 * 工作台右栏、侧栏「即将上线」组、/coming-soon 页共用;后端加/上线一个预留模块,前端零改动自动同步。
 */
export function useComingSoonModules() {
  return useQuery<ComingSoonModule[]>({
    queryKey: ["me", "coming-soon"],
    queryFn: dashboardService.listComingSoon,
    staleTime: 5 * 60_000,
  });
}
